// extracted by mini-css-extract-plugin
export var dataCell = "_ny-2";
export var dataRow = "_ny-0";
export var headerRow = "_ny-1";